import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Services from "@/pages/services/page";
import ServiceDetail from "@/pages/service-detail/page";
import SpineCare from "@/pages/spine-care/page";
import OrthopaedicCare from "@/pages/orthopaedic-care/page";
import Gallery from "@/pages/gallery/page";
import Blog from "@/pages/blog/page";
import BlogDetail from "@/pages/blog-detail/page";
import Contact from "@/pages/contact/page";
import BookAppointment from "@/pages/book-appointment/page";
import PrivacyPolicy from "@/pages/privacy-policy/page";
import TermsConditions from "@/pages/terms-conditions/page";
import Disclaimer from "@/pages/disclaimer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/spine-care",
    element: <SpineCare />,
  },
  {
    path: "/services/orthopaedic-care",
    element: <OrthopaedicCare />,
  },
  {
    path: "/services/:slug",
    element: <ServiceDetail />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/appointment",
    element: <BookAppointment />,
  },
  {
    path: "/book-appointment",
    element: <Navigate to="/appointment" replace />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsConditions />,
  },
  {
    path: "/terms-conditions",
    element: <Navigate to="/terms" replace />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;